import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  //   Box,
  //   Typography,
  Chip,
  FormControl,
  //   Divider,
  SelectChangeEvent,
} from "@mui/material";
// import { useAuth } from "../../../../hooks/useAuth";
import {
  AppTextField,
  AppButton,
  AppSelectField,
  AppConfirmationModal,
} from "../../../components";
// import Alert from "@mui/material/Alert";
// import AlertTitle from "@mui/material/AlertTitle";

import {
  TicketCustomer,
  TicketCustomerBox,
  TicketCustomerTxt,
  TicketCustomerInfo,
  TicketCustomerInfoTxt,
  TicketReply,
  //   TicketReplyLeftPanel,
  TicketReplyMiddlePanel,
  TicketReplyMiddleBox,
  Buttonset,
} from "../styles/TicketDetails.styles";
import {
  // AgentService,
  TicketService,
} from "../../../services";
import { useParams } from "react-router-dom";
import {
  //   getFormattedDateTime,
  getTicketClass,
  getTicketStatus,
  //   getUserName,
} from "../../../utils/helpers";
import {
  // Agent,
  Ticket,
} from "../../../types";
import {
  ALL_TICKET_INTERNAL_STATUS,
  //   ALL_TICKET_STATUS,
  //   TICKET_PRIORITY_OPTIONS,
  //   USER_STATUSES,
} from "../../../utils/constants";
import TicketDetailsRightPanel from "./TicketDetails.RightPanel";
import TicketDetailsConversations from "./TicketDetails.Conversations";
import CustomerTicketDetailsEmailReply from "./CustomerTicketDetailsEmailReply";
import CustomerService from "../../../services/Customer.Service";

export default function TicketDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  //   const user = useAuth();
  const [ticketDetails, setTicketDetails] = useState<Ticket | null>(null);
  //   const [agentList, setAgentList] = useState<Agent[]>([]);

  // modal state: which field and what new value
  const [modal, setModal] = useState<{
    type?: "status" | "priority";
    value?: string;
  }>({});

  const [formData, setFormData] = useState({
    assignedTo: "",
    movingNote: "",
    selfNote: "",
    status: "",
    priority: "",
    internalStatus: ALL_TICKET_INTERNAL_STATUS[0].value,
    emailBody: "",
  });
  const {
    assignedTo,
    movingNote,
    selfNote,
    // status,
    // priority,
    internalStatus,
  } = formData;

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (e: SelectChangeEvent<unknown>) => {
    const name = e.target.name as string;
    const value = e.target.value as string;

    if (name === "status" || name === "priority") {
      setModal({ type: name as "status" | "priority", value });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const closeModal = () => setModal({});

  // perform actual update after confirmation
  const applyChange = async () => {
    if (modal.type === "status" && modal.value) {
      const resp = await TicketService.updateStatus({
        ticket_id: id,
        status: modal.value,
        id,
      });
      setTicketDetails((prev) => ({ ...prev!, ...resp.data }));
      setFormData((prev) => ({ ...prev, status: modal.value! }));
    } else if (modal.type === "priority" && modal.value) {
      await TicketService.updatePriority({ priority: modal.value, id });
      setFormData((prev) => ({ ...prev, priority: modal.value! }));
    }

    setModal({});
  };

  // helper: modal message
  const modalMessage =
    modal.type === "status"
      ? `Are you sure you want to change status?`
      : `Are you sure you want to change priority?`;

  const getTicketDetails = async () => {
    try {
      const resp = await CustomerService.getTicketDetails({
        id,
      });
      setTicketDetails(resp.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //   const getAgentList = async () => {
  //     try {
  //       const resp = await AgentService.getList({
  //         limit: 100,
  //         add: ["userDetails"],
  //         filters: [{ "$userDetails.status$": USER_STATUSES.ACTIVE }],
  //       });
  //       const data = resp?.data?.data || [];
  //       setAgentList(data);
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };

  const handleAssign = async () => {
    try {
      await TicketService.assign({
        ticket_id: id,
        assignedTo,
        movingNote,
        selfNote,
        status: internalStatus,
        id,
      });
      navigate("/tickets");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getTicketDetails();
  }, []);

  //   const checkEscalated = () =>
  //     !!ticketDetails?.assignmentHistory?.find((h) => h.status === "escalated");

  const columnLimited = document.querySelector(".ticketMidPanel");
  const otherColumn = document.querySelector(".ticketRightPanel");

  if (
    columnLimited instanceof HTMLElement &&
    otherColumn instanceof HTMLElement
  ) {
    const limitedHeight = columnLimited.offsetHeight;
    otherColumn.style.height = `${limitedHeight}px`;
  }

  return (
    <>
      <TicketCustomer>
        <TicketCustomerBox>
          <TicketCustomerTxt>Customer</TicketCustomerTxt>
          <TicketCustomerInfo>
            <Chip
              size="small"
              label={getTicketStatus(ticketDetails)}
              className={getTicketClass(ticketDetails)}
            />
            <TicketCustomerInfoTxt>
              {" "}
              Ticket Id : {ticketDetails?.ticketId}{" "}
            </TicketCustomerInfoTxt>
          </TicketCustomerInfo>
        </TicketCustomerBox>

        {/* {checkEscalated() && <Chip size="small" label="Escalated" className="red" sx={{ml:'auto'}}/>} */}
      </TicketCustomer>

      <TicketReply>
        {/* <TicketReplyLeftPanel> */}
        {/* {checkEscalated() ? (
            <Chip size="small" label="Escalated" className="red" />
          ) : (
            <Typography
              component="span"
              sx={{
                display: "block",
                color: "#000",
                fontSize: 16,
                lineHeight: "20px",
                fontWeight: 500,
              }}
            >
              {getTicketStatus(ticketDetails)}
            </Typography>
          )} */}
        {/* <Typography
            component="span"
            sx={{
              color: "#7F7F7F",
              fontSize: 12,
              lineHeight: "12px",
              fontWeight: 400,
              mt: 0.75,
            }}
          >
            {getFormattedDateTime(ticketDetails?.createdAt)}
          </Typography> */}
        {/* <Divider sx={{ my: 3, borderBottom: "none" }} /> */}
        {/* <FormControl fullWidth className="v2" sx={{ mb: 2 }}>
            <AppSelectField
              label="Re-Assign"
              name="assignedTo"
              onChange={handleSelectChange}
              value={assignedTo || String(ticketDetails?.assignedAgent?.id)}
              options={[
                {
                  value: String(user?.id) || "",
                  label: getUserName(user) || "",
                },
                ...agentList.map((agent) => ({
                  value: String(agent.id),
                  label: getUserName(agent),
                })),
              ]}
            />
          </FormControl> */}
        {/* <FormControl fullWidth className="v2" sx={{ mb: 2 }}>
            <AppSelectField
              label="Ticket Status"
              name="status"
              options={ALL_TICKET_STATUS}
              onChange={handleSelectChange}
              value={
                status || ticketDetails?.status || ALL_TICKET_STATUS[0].value
              }
              disabled
            />
          </FormControl>
          <Divider sx={{ mb: 3, mt: 1, borderBottom: "none" }} />
          <FormControl fullWidth className="v2" sx={{ mb: 2 }}>
            <AppSelectField
              label="Priority*"
              name="priority"
              options={TICKET_PRIORITY_OPTIONS}
              onChange={handleSelectChange}
              value={priority || ticketDetails?.priority || "low"}
              disabled
            />
          </FormControl> */}
        {/* </TicketReplyLeftPanel> */}

        <TicketReplyMiddlePanel className="ticketMidPanel">
          {assignedTo &&
            assignedTo != String(ticketDetails?.assignedAgent?.id) && (
              <>
                <TicketReplyMiddleBox className="with-gap">
                  <FormControl fullWidth className="v2" sx={{ mb: 2 }}>
                    <AppSelectField
                      label="Ticket Internal Status"
                      name="internalStatus"
                      options={ALL_TICKET_INTERNAL_STATUS}
                      onChange={handleSelectChange}
                      value={internalStatus}
                    />
                  </FormControl>
                  <FormControl fullWidth className="v2" sx={{ mb: 2 }}>
                    <AppTextField
                      onChange={handleChange}
                      label={"Note for next assignee"}
                      value={movingNote}
                      name={"movingNote"}
                      multiline
                      maxRows={2}
                      minRows={2}
                      placeholder="Type here..."
                      InputLabelProps={{ shrink: true }}
                    />
                  </FormControl>

                  <Buttonset>
                    <AppButton variant="contained" onClick={handleAssign}>
                      Assign
                    </AppButton>
                  </Buttonset>
                </TicketReplyMiddleBox>
              </>
            )}
          <TicketReplyMiddleBox>
            <TicketDetailsConversations ticketDetails={ticketDetails} />
            <CustomerTicketDetailsEmailReply
              ticketDetails={ticketDetails}
              supportEmail={ticketDetails?.tenant?.sendgridUser?.fromEmail}
              setTicketDetails={setTicketDetails}
            />
          </TicketReplyMiddleBox>
        </TicketReplyMiddlePanel>
        <TicketDetailsRightPanel ticketDetails={ticketDetails} />
      </TicketReply>

      {/* Confirmation Modal */}
      <AppConfirmationModal
        open={Boolean(modal.type)}
        onClose={closeModal}
        message={modalMessage}
        onSuccess={async () => {
          await applyChange();
        }}
        onFail={closeModal}
      />
    </>
  );
}
